import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/Identity`;

class UserService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getUser(userId: string): Promise<IApiResponse | void> {
    try {
      this.url = `${url}/UserProfiles`;
      return super.getById(userId);
    } catch (e) {
      throw e;
    }
  }

  public updateUser(body: any): Promise<IApiResponse | void> {
    try {
      this.url = `${url}/UserProfiles`;
      return super.update(body, '');
    } catch (e) {
      throw e;
    }
  }

  public createUser(body: any): Promise<IApiResponse | void> {
    try {
      this.url = `${url}/UserProfiles`;
      return super.create(body);
    } catch (e) {
      throw e;
    }
  }

  public removeUser(userId: string): Promise<IApiResponse | void> {
    try {
      this.url = `${url}/UserProfiles`;
      return super.delete(userId)
    } catch (e) {
      throw e;
    }
  }

  public searchUser(body: any): Promise<IApiResponse | void> {
    try {
      this.url = `${url}`;
      return super.create(body, { name: "SearchUser" });
    } catch (e) {
      throw e;
    }
  }
}
const userAPI = new UserService(url);
export default userAPI;
